import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-Handshake',
  standalone: true,
  templateUrl: '../../assets/Handshake.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamHandshakeIcon {}
